import { ChannelUnsubscribe, channelClient } from 'shared/channels';
import { DomainMessagesTypes } from 'shared/domain/messages/message';
import { apiVersionContract } from './apiVersionContract';

/** Hearing that the API refused this app version. */
export const apiVersionClient = {
  onVersionMismatch(handler: () => void): ChannelUnsubscribe {
    return channelClient.onEventOfType(apiVersionContract, DomainMessagesTypes.apiVersionMismatch, () => handler());
  },
};
